import axios from "../axiosInstance";
import {
  ShareResourceToEmployeesParams,
  ShareResourceToEmployeesResponse,
} from "./types";

export const shareResourceToEmployees = async (
  params: ShareResourceToEmployeesParams,
): Promise<ShareResourceToEmployeesResponse> => {
  const response = await axios.post<ShareResourceToEmployeesResponse>(
    `/api/private/resources/${params.resourceUuid}/share`,
    { employeeUuids: params.employeeUuids },
  );
  return response.data;
};
